export default __webpack_public_path__ + "static/desk10-9f54abf6d552865033a6a4533fac221d.png";